import type { ComponentChildren } from 'preact';

interface CardProps {
  children: ComponentChildren;
  /** Only the `sm-card-*` modifiers (e.g. `sm-card-centered`) belong here. */
  className?: string;
}

export function Card({ children, className }: CardProps) {
  return (
    <div className={['sm-panel', 'sm-stack sm-card', className].filter(Boolean).join(' ')}>
      {children}
    </div>
  );
}

interface CardIntroProps {
  title: string;
  subtitle?: ComponentChildren;
}

export function CardIntro({ title, subtitle }: CardIntroProps) {
  return (
    <div className="sm-stack sm-card-intro">
      <h1 className="sm-type-title">{title}</h1>
      {subtitle !== undefined && <p className="sm-type-body sm-muted">{subtitle}</p>}
    </div>
  );
}
